<template>
    <el-drawer
        title="管理歌曲"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-form-item prop="display" label="状态:">
                    <el-radio-group v-model="formData.display" size="medium">
                        <el-radio :label="1">显示</el-radio>
                        <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="name" label="名称:">
                    <el-input v-model="formData.name" placeholder="请输入歌曲名称" size="medium"></el-input>
                </el-form-item>
                <el-form-item prop="styles" label="风格:" >
                    <el-cascader
                        v-if="drawerShow"
                        v-model="styles"
                        :options="styleList"
                        filterable
                        :props="{multiple:true,label:'name',children:'tags',value:'id',emitPath:true,checkStrictly:true}"
                        size="medium"
                        style="width:100%"
                        @change="selectStyles">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.name }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.tags.length }}) </span>
                        </template>
                    </el-cascader>
                </el-form-item>
                <el-form-item v-if="formData && formData.playUrl" label="文件:">
                    {{formData.name+'.'+$utils.getFileType(formData.playUrl)}} 
                    <el-button icon="el-icon-download" @click="download" :loading="downLoading" size="mini" type="text">点击下载</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllTag,downloadFile} from '@/assets/js/commonApi'
const defaultFormData = {
    display:1,
    name:"",
    styles:[],
    tags:[]
}
export default {
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                name: [{ required: true, message: "请输入歌曲名称" }],
                styles: [{ required: true, message: "请选择音乐风格" }],
            },
            styles:[],
            styleList:[],//所有风格Tag集合
            styleArray:[],
            id:'',
            downLoading: false,
        }
    },
    created(){
        this.getStyleList();
    },
    methods:{
        //获取所有风格
        async getStyleList(){
            const res = await fetchAllTag({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.styleArray = result;
            }
        },
        close() {
            // this.formData = {...defaultFormData};
            this.styles = [];
            this.styleList = [];
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        show(id) {
            this.id = id;
            this.getData();   
            this.drawerShow = true;
        },

        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/music/detail',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            styles: result.styles ? result.styles.split(',') : [],
                            tags : result.tags ? result.tags.split(',') : []
                        }
                        if(result && result.tagVOS){

                            result.tagVOS.map(item => {
                                const _arry = [];
                                _arry.push(item.styleId);

                                // this.formData.styles.push(item.styleId);
                                if(item.tagId){
                                    // this.formData.tags.push(item.tagId);
                                    _arry.push(item.tagId);
                                }
                                
                                this.styles.push(_arry);
                            })
                            this.styles = Array.from(this.styles).sort((x,y) => x[0] - y[0]);
                        }
                        this.styleList = [...this.styleArray];
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });   
        },

        //选取风格
        selectStyles(){
            // 风格&tag id组装
            let _styles = [], _tags = [];
            this.styles.forEach( item =>  {
                _styles.push( item[0] );
                if(item[1]){
                    _tags.push( item[1] ); 
                }
            })

            this.formData.styles = _styles ? [...new Set(_styles)] : [];
            this.formData.tags = _tags ? [...new Set(_tags)] : [];
        },
        
        // 表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()
                } else {
                    return false;
                }
            });
        },
        submitAction(){
            const _url = "/music/update";
            this.btnLoading = true;
            this.$request({
                url: _url,
                data: {
                    ...this.formData,
                    styles: this.formData.styles.toString(),
                    tags: this.formData.tags.toString(),
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        },
        //下载文件
        async download(){
            this.downLoading = true;
            const _url = this.formData.playUrl;
            await downloadFile(_url,this.formData.name+'.'+this.$utils.getFileType(_url));
            this.downLoading = false;
        },
    }
}
</script>
